export default __webpack_public_path__ + "static/media/hotel0floormap.f586ca34.png";